import { createSelector } from 'reselect';
import USER_TYPE from '../../constants/userType';

export const getUserId = state => state.userId;

export const getPersistedUserId = state => state.persistedUserId;

export const getUserName = state => state.userName;

export const getUserType = state => state.userType;

export const getIsLanternUser = createSelector(
    [getUserId, getUserType],
    (userId, userType) => userId !== undefined && userType === USER_TYPE.STUDENT,
);
export const getAuthenticationFailed = state => state.authenticationFailed;

export const getAquaId = state => state.aquaId;
